<div arria-hidden="true">
    <h-tag
        [appearance]="'square'"
        [tagSize]="(isMobile$ | async) === true ? 'xsmall' : 'small'"
        [backgroundColor]="'white'"
        [backgroundOpacity]="0.8">
        <div>
            @if (product.labelDisplayOnly === 'exceptional-product') {
            <div class="vertical-align">
                <span i18n="@@hermes-grid-tag.exceptional-pieces" class="label-small-bold-uppercase">Unavailable</span>
            </div>
            } @else {
            <div class="vertical-align">
                <span i18n="@@hermes-grid-tag.unavailable" class="label-small-bold-uppercase">Available soon</span>
            </div>
            }
            <ng-template #unavailable>
                <div class="vertical-align">
                    <span i18n="@@hermes-grid-tag.unavailable" class="label-small-bold-uppercase">Available soon</span>
                </div>
            </ng-template>
        </div>
    </h-tag>
</div>
